import { makeStyles } from '@material-ui/core';

const styles = (theme) => ({
  container: {
    width: 720,
    margin: '0 auto',
    padding: 32
  },
  sectionWithLine: {
    borderTop: `1px solid ${theme.colorPalette.white_40_op_70}`,
    marginTop: 20,
    paddingTop: 25
  },
  paymentBlock: {
    paddingBottom: 25
  },
  secondaryPhoneContainer: {
    border: '3px solid white',
    borderRadius: 3,
    padding: '10px 0px 10px 20px',
    margin: '15px 0px'
  },
  textCheckbox: {
    marginLeft: '5px'
  }
});

export default makeStyles(styles);
